import React from 'react';

/**
 * 전투기록 창의 공덱·방덱을 **승패 상자**로 감싼다(사용자 2026-10-13): 이긴 쪽은 파란 테두리 + 위에 WIN,
 * 진 쪽은 빨간 테두리 + 위에 LOSE.
 *
 * `result` 는 우리 쪽 기준이다(방어 기록이면 막았으면 `'win'`). `ours` 가 아니면 뒤집어 상대 칸에 단다.
 * 승패가 없는 글(공략·게시글)이나 고치는 중에는 상자를 그리지 않는다.
 */
const hasResult = (result?: string) => result === 'win' || result === 'lose';
const isWin = (result: string | undefined, ours: boolean) => (result === 'win') === ours;

/** 덱 칸에 덧붙일 상자 모양 — 그리지 않을 때는 빈 객체 */
export function resultBoxStyle(result: string | undefined, ours: boolean, off?: boolean, small?: boolean): React.CSSProperties {
  if (off || !hasResult(result)) return {};
  const win = isWin(result, ours);
  return {
    flex: '0 1 auto',
    position: 'relative',
    border: `2px solid ${win ? '#2196f3' : '#f44336'}`,
    borderRadius: small ? 12 : 16,
    background: win ? 'rgba(33, 150, 243, 0.06)' : 'rgba(244, 67, 54, 0.06)',
    padding: small ? '16px 8px 8px' : '20px 14px 12px'
  };
}

/** 상자 위 가운데 WIN / LOSE */
export default function ResultPill({ result, ours, off, small }: { result?: string; ours: boolean; off?: boolean; small?: boolean }) {
  if (off || !hasResult(result)) return null;
  const win = isWin(result, ours);
  return (
    <span style={{
      position: 'absolute',
      top: 0,
      left: '50%',
      transform: 'translate(-50%, -50%)',
      padding: small ? '1px 10px' : '2px 14px',
      borderRadius: 10,
      fontSize: small ? 11 : 13,
      fontWeight: 800,
      letterSpacing: 0.5,
      color: '#fff',
      background: win ? '#2196f3' : '#f44336',
      lineHeight: 1.4,
      whiteSpace: 'nowrap'
    }}>{win ? 'WIN' : 'LOSE'}</span>
  );
}

/** 두 상자 사이 VS */
export function ResultVs({ result, off, small }: { result?: string; off?: boolean; small?: boolean }) {
  if (off || !hasResult(result)) return null;
  return (
    <div style={{
      alignSelf: 'center',
      fontSize: small ? 20 : 28,
      fontWeight: 900,
      color: '#7b83eb',
      fontStyle: 'italic'
    }}>VS</div>
  );
}
